module.exports = __webpack_public_path__ + "static/img/zipai.0cdd8728.png";